import { HttpClient } from '@angular/common/http';
import { Site } from './../../../core/models/site.model';
import { ReadCounts } from './../../../core/models/read-counts.model';
import { AuthService } from './../../../core/services/auth.service';
import { BaseUser } from './../../../core/models/base-user.model';
import { Staff } from './../../../core/models/staff.model';
import { Resident } from './../../../core/models/resident.model';
import { Administrator } from '../../../core/models/administrator.model';
import { MessageSet } from './../../../core/models/message-set.model';
import { MessageRecipientService } from './../../../core/services/message-recipient.service';
import { MessageSetService } from './../../../core/services/message-set.service';
import { LoggerService } from './../../../core/services/logger.service';
import { Injectable } from '@angular/core';
import { PusherService } from 'src/app/core/services/pusher.service';
import { MessageRecipient } from 'src/app/core/models/message-recipient.model';
import { Store } from '@ngrx/store';
import {
  UserState,
} from 'src/app/login/state/user.reducers';
import { Customer } from 'src/app/core/models/customer.model';
import { MessageBoxSubscription } from '../state/messages.reducer';
import * as MessagesActions from '../state/messages.actions';
import * as SiteSelectors from '../../sites/state/site.selectors';
import { Channel } from 'pusher-js';

export interface MessageSetNotification {
  message_set_id: number;
}

export interface MessageRecipientNotification {
  message_recipient_id: number;
  message_set_id: number;
  recipient_id: number;
}

@Injectable()
export class MessageboxService {
  messageSets: MessageSet[];
  currentMessageSet: MessageSet;

  administrators: Administrator[];
  residents: Resident[];
  staff: Staff[];
  senders: BaseUser[];

  busy: boolean = false;
  loading: boolean = false;
  loadingRecipients: boolean = false;
  totalMessageCount: number;
  next: string = null;

  readCounts: ReadCounts = new ReadCounts();

  searchQuery: string = '';
  searchExecuted: boolean = false;
  filterSite: Site;
  filterRecipient: Resident;
  filterSender: BaseUser;
  filterFromDate: Date;
  filterToDate: Date;

  constructor(
    private logger: LoggerService,
    private messageSetService: MessageSetService,
    private messageRecipientService: MessageRecipientService,
    private pusher: PusherService,
    private auth: AuthService,
    private http: HttpClient,
    private store$: Store<UserState>
  ) {}

  getChannelName(customer: Customer, site: Site): string {
    return `presence-messagebox-${customer.slug}-${site.slug}`;
  }

  subscribe(customer: Customer, site: Site) {
    const channelName = this.getChannelName(customer, site);
    const channel = this.pusher.subscribe(channelName);
    this.pusher.bindChannelEvent(
      channel,
      'pusher:subscription_succeeded',
      (channel: Channel) =>
        this.store$.dispatch(
          MessagesActions.subscribeMessageBoxChannelSuccess({
            subscription: { channelName, siteId: site.id },
          })
        )
    );

    this.pusher.bindChannelEvent(
      channel,
      'pusher:subscription_error',
      (error: Error) =>
        this.store$.dispatch(
          MessagesActions.subscribeMessageBoxChannelFailure(error)
        )
    );

    this.pusher.bindChannelEvent(
      channel,
      'message_set_created',
      this.onMessageSetCreated.bind(this)
    );

    this.pusher.bindChannelEvent(
      channel,
      'message_set_updated',
      this.onMessageSetUpdated.bind(this)
    );

    this.pusher.bindChannelEvent(
      channel,
      'message_recipient_updated',
      this.onMessageRecipientUpdated.bind(this)
    );
  }

  unsubscribe(subscription: MessageBoxSubscription) {
    const channel = this.pusher.channel(subscription.channelName);
    if (channel && channel.subscribed) {
      this.pusher.unsubscribe(channel.name);
      this.logger.info(`unsubscribed: ${channel.name}`);
    }
  }

  onMessageSetCreated(notification: MessageSetNotification) {
    this.logger.info(`messageSetCreated: ${JSON.stringify(notification)}`);
    this.store$.dispatch(
      MessagesActions.getMessageSet({
        messageSetId: notification.message_set_id,
      })
    );
  }

  onMessageSetUpdated(notification: MessageSetNotification) {
    this.logger.info(`messageSetUpdated: ${JSON.stringify(notification)}`);
    this.store$.dispatch(
      MessagesActions.updateMessageSet({
        messageSetId: notification.message_set_id,
      })
    );
  }

  onMessageRecipientUpdated(notification: MessageRecipientNotification) {
    this.logger.info(
      `messageRecipientUpdated: ${JSON.stringify(notification)}`
    );

    this.store$.dispatch(
      MessagesActions.pusherMessageRecipientUpdated({ notification })
    );

    // this.store$.dispatch(
    //   MessagesActions.getRecipientsForMessageSet({
    //     messageSetId: notification.message_set_id,
    //   })
    // );

    // this.store$.dispatch(
    //   MessagesActions.pusherMessageRecipientUpdated({ messageRecipient })
    // );

    // this.messageRecipientService
    //   .getMessageRecipient(data.message_recipient_id)
    //   .subscribe(
    //     (updatedMessageRecipient: MessageRecipient) => {
    //       const messageSetIndex = this.messageSets.findIndex(
    //         (element) => element.id === updatedMessageRecipient.message_set.id
    //       );
    //       if (messageSetIndex !== -1) {
    //         if (
    //           !this.messageSets[messageSetIndex].hasOwnProperty(
    //             'messageRecipients'
    //           )
    //         ) {
    //           // no messageRecipients present
    //           this.messageRecipientService
    //             .getMessageRecipientsForMessageSet(
    //               updatedMessageRecipient.message_set.id
    //             )
    //             .subscribe(
    //               (messageRecipients: MessageRecipient[]) => {
    //                 this.messageSets[messageSetIndex].messageRecipients =
    //                   messageRecipients;
    //                 this.messageSets[messageSetIndex].recipients = [];
    //                 messageRecipients.forEach(
    //                   (messageRecipient: MessageRecipient) => {
    //                     this.messageSets[messageSetIndex].recipients.push(
    //                       messageRecipient.recipient
    //                     );
    //                   }
    //                 );
    //               },
    //               (error) =>
    //                 this.logger.error(
    //                   `Failed to get messageRecipients for message set: ${updatedMessageRecipient.id}`
    //                 )
    //             );
    //         } else {
    //           // recipients already present
    //           // update with newly received update
    //           const messageRecipientIndex = this.messageSets[
    //             messageSetIndex
    //           ].messageRecipients.findIndex(
    //             (messageRecipient: MessageRecipient) =>
    //               messageRecipient.id === updatedMessageRecipient.id
    //           );
    //           this.messageSets[messageSetIndex].messageRecipients[
    //             messageRecipientIndex
    //           ] = updatedMessageRecipient;
    //         }

    //         this.updateReadCounts();
    //       } else {
    //         this.logger.warn(
    //           `Couldn't find message set id: ${updatedMessageRecipient.message_set.id}`
    //         );
    //       }

    //       // Is the message set being updated the currentMessageSet
    //       if (
    //         this.currentMessageSet &&
    //         this.currentMessageSet.id === updatedMessageRecipient.message_set.id
    //       ) {
    //         this.currentMessageSet = this.messageSets[messageSetIndex];
    //       }
    //     },
    //     (error) =>
    //       this.logger.error(
    //         `Failed to get message recipient: ${data.messge_recipient_id}`
    //       )
    //   );
  }

  doSearch() {
    this.searchExecuted = true;
    this.store$.dispatch(
      MessagesActions.searchMessageSets({
        searchQuery: this.searchQuery,
        siteId: this.filterSite ? this.filterSite.id : undefined,
        senderId: this.filterSender ? this.filterSender.id : undefined,
      })
    );
  }

  clearSearch() {
    this.searchQuery = '';
    this.searchExecuted = false;
    this.store$.dispatch(MessagesActions.clearSearch());
  }

  clearFilterRecipient() {
    this.filterRecipient = null;
    this.doSearch();
  }

  clearFilterSite() {
    this.filterSite = null;
    this.doSearch();
  }

  clearFilterSender() {
    this.filterSender = null;
    this.doSearch();
  }

  clearFilterFromDate() {
    this.filterFromDate = null;
    this.doSearch();
  }

  clearFilterToDate() {
    this.filterToDate = null;
    this.doSearch();
  }

  setFilterRecipient(recipient) {
    this.filterRecipient = recipient;
    this.doSearch();
  }

  setFilterSite(site) {
    this.filterSite = site;
    this.doSearch();
  }

  setFilterSender(sender) {
    this.filterSender = sender;
    this.doSearch();
  }

  setFilterFromDate(fromDate) {
    this.filterFromDate = fromDate;
    this.doSearch();
  }

  setFilterToDate(toDate) {
    this.filterToDate = toDate;
    this.doSearch();
  }
}
